module.exports = __webpack_public_path__ + "img/info-info.7c0f1c9f.svg";